


function renderSpecs(variantId) {
  const specsJson = document.getElementById("variant-specs-json");
  const specsData = JSON.parse(specsJson.textContent);
  const specsContainer = document.getElementById("details-specs-container");

  const data = specsData.variants[variantId];
  const product = specsData.product;
  if (data) {
    specsContainer.innerHTML = `
        <div class="spec-section">
          <div class="spec-header Para5">
            <img src="https://cdn.shopify.com/s/files/1/0665/3349/0748/files/Group_48096605.svg?v=1749806389">
            Metal details
          </div>
          <table class="spec-table ">
            <tr><td>Metal Purity</td><td class="align-right">${
              data.metal_purity || "-"
            }</td></tr>
            <tr><td>Gross Weight(g)</td><td class="align-right">${
              data.gross_weight || "-"
            }</td></tr>
            <tr><td>Net Weight(g)</td><td class="align-right">${
              data.net_weight || "-"
            }</td></tr>
          </table>
        </div>

        <div class="spec-section">
         
        </div>
      `;
  } else {
    specsContainer.innerHTML =
      "<p>No specifications available for this variant.</p>";
  }
}
// function updatePriceSection(variantId) {
//   const priceEl = document.querySelector('[id^="Price-Per-Item-"]');
//   if (!priceEl) return;

//   const sectionId = priceEl.dataset.sectionId;
//   if (!sectionId) return;

//   const url = `${window.location.pathname}?variant=${variantId}&section_id=${sectionId}`;

//   fetch(url)
//     .then(res => res.text())
//     .then(html => {
//       const tempDiv = document.createElement('div');
//       tempDiv.innerHTML = html;

//       const newPriceEl = tempDiv.querySelector(`#Price-Per-Item-${sectionId}`);
//       if (newPriceEl) {
//         priceEl.innerHTML = newPriceEl.innerHTML;

//       } else {

//       }
//     })
//     .catch(err => console.error("❌ Price update failed:", err));
// }

function updatePriceSection(variantId) {
  const priceEls = document.querySelectorAll('[id^="Price-Per-Item-"]');

  if (!priceEls.length) return;

  priceEls.forEach((priceEl) => {
    const sectionId = priceEl.dataset.sectionId;
    if (!sectionId) return;

    const url = `${window.location.pathname}?variant=${variantId}&section_id=${sectionId}`;

    fetch(url)
      .then((res) => res.text())
      .then((html) => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;

        const newPriceEl = tempDiv.querySelector(
          `#Price-Per-Item-${sectionId}`
        );
        if (newPriceEl) {
          priceEl.innerHTML = newPriceEl.innerHTML;
        }
      })
      .catch((err) => console.error(" Price update failed:", err));
  });
}

document.addEventListener("DOMContentLoaded", function () {
  const initialVariantId = document.querySelector('input[name="id"]')?.value;
  if (initialVariantId) renderSpecs(initialVariantId);

  document
    .querySelector('form[action^="/cart/add"]')
    ?.addEventListener("change", function () {
      const newVariantId = document.querySelector('input[name="id"]')?.value;
      if (newVariantId) renderSpecs(newVariantId);
    });

  document.querySelectorAll(".variant-trigger").forEach((el) => {
    el.addEventListener("click", () => {
      document.getElementById("variant-drawer").classList.add("is-open");
    });
  });
  document.querySelectorAll(".metal-option").forEach((el) => {
    el.classList.remove("active");
    if (el.dataset.metal === selectedMetal) el.classList.add("active");
  });

  document.querySelectorAll(".size-option").forEach((el) => {
    el.classList.remove("active");
    if (el.dataset.size === selectedSize) el.classList.add("active");
  });

  document.querySelectorAll(".metal-option").forEach((el) => {
    el.addEventListener("click", () => {
      document
        .querySelectorAll(".metal-option")
        .forEach((m) => m.classList.remove("active"));
      el.classList.add("active");
      selectedMetal = el.getAttribute("data-metal");
    });
  });

  // document.querySelectorAll('.size-option').forEach(el => {
  //   el.addEventListener('click', () => {
  //     document.querySelectorAll('.size-option').forEach(s => s.classList.remove('active'));
  //     el.classList.add('active');
  //     selectedSize = el.getAttribute('data-size');
  //   });
  // });
  const sizeOptions = document.querySelectorAll(".size-option");

  if (sizeOptions.length > 0) {
    sizeOptions.forEach((el) => {
      el.addEventListener("click", () => {
        sizeOptions.forEach((s) => s.classList.remove("active"));
        el.classList.add("active");
        selectedSize = el.getAttribute("data-size");

        // Update size display if present
        const sizeDisplay = document.getElementById("selected-size");
        const stickysizeDisplay = document.getElementById(
          "sticky-selected-size"
        );

        if (sizeDisplay) {
          sizeDisplay.innerText = selectedSize ? `Size ${selectedSize}` : "";
          // Optional: sizeDisplay.style.display = selectedSize ? '' : 'none';
        }

        if (stickysizeDisplay) {
          stickysizeDisplay.innerText = selectedSize
            ? `Size ${selectedSize}`
            : "";
          // Optional: stickysizeDisplay.style.display = selectedSize ? '' : 'none';
        }
      });
    });
  } else {
    // No size options at all → clear or hide display
    const sizeDisplay = document.getElementById("selected-size");
    const stickysizeDisplay = document.getElementById("sticky-selected-size");

    if (sizeDisplay) sizeDisplay.innerText = "";
    if (stickysizeDisplay) stickysizeDisplay.innerText = "";
    // Optional: hide instead of clear
    // if (sizeDisplay) sizeDisplay.style.display = 'none';
    // if (stickysizeDisplay) stickysizeDisplay.style.display = 'none';
  }
});
function showVariantAlert(message) {
  const alertBox = document.getElementById("variant-alert");
  alertBox.textContent = message;
  alertBox.classList.remove("hidden");
}

function hideVariantAlert() {
  const alertBox = document.getElementById("variant-alert");
  alertBox.classList.add("hidden");
}

window.productData = JSON.parse(
  document.getElementById("product-json").textContent
);

// let selectedMetal = window.productData.variants[0].option1;
// let selectedSize = window.productData.variants[0].option2;

let currentVariantId =
  new URLSearchParams(window.location.search).get("variant") ||
  document.querySelector('input[name="id"]')?.value;

let currentVariant = window.productData.variants.find(
  (v) => v.id == currentVariantId
);

let selectedMetal =
  currentVariant?.option1 || window.productData.variants[0].option1;
let selectedSize =
  currentVariant?.option2 || window.productData.variants[0].option2 || null;

document
  .getElementById("apply-variant-selection")
  .addEventListener("click", () => {
    if (!selectedMetal) {
      showVariantAlert("Please select metal");
      return;
    }

    if (!selectedSize) {
      showVariantAlert("Please select size");
      return;
    }

    hideVariantAlert();
        function normalizeSize(value) {
  if (!value) return "";
  return value.toString().trim().replace(/['"]/g, "").toLowerCase();
}

  const matchedVariant = window.productData.variants.find(
  (variant) =>
    variant.option1 === selectedMetal &&
    normalizeSize(variant.option2) === normalizeSize(selectedSize)
);





    if (!matchedVariant) {
      showVariantAlert("No matching variant found.");
      return;
    }



    // const variantInput = document.querySelector('input[name="id"].product-variant-id');
    // if (variantInput) {
    //   variantInput.value = matchedVariant.id;
    //   variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    // }
    const variantInput = document.querySelector(
      'input[name="id"].product-variant-id'
    );
    if (variantInput) {
      variantInput.value = matchedVariant.id;

      // Trigger full Shopify variant change behavior
      const form = variantInput.closest("form");
      if (form) {
        form.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }

        if (variantInput && variantInput.value) {
    setTimeout(() => {
      updateEstimatedDelivery(variantInput.value);
    }, 100);
  }


    const stickyvariantInput = document
      .getElementById("StickyProductBar")
      .querySelector('input[name="id"].product-variant-id');
    if (stickyvariantInput) {
      stickyvariantInput.value = matchedVariant.id;
      stickyvariantInput.dispatchEvent(new Event("change", { bubbles: true }));
    }

    const newUrl = `${window.location.pathname}?variant=${matchedVariant.id}`;
    window.history.replaceState({ path: newUrl }, "", newUrl);
    console.log(matchedVariant.available);

    if (!matchedVariant.available) {
      document.querySelector(".metal-swatch-circle").classList.add("active");
      document
        .querySelector(".product-form__submit")
        .setAttribute("aria-disabled", true);
      document
        .querySelector(".product-form__submit")
        .querySelector("span").innerHTML = "Sold Out";
      // document.getElementById('delivery-home-trial-box').classList.add('hidden');
    } else {
      document
        .querySelector(".product-form__submit")
        .removeAttribute("aria-disabled");
      document
        .querySelector(".product-form__submit")
        .querySelector("span").innerHTML = "Add To Cart";
      // document.getElementById('delivery-home-trial-box').classList.remove('hidden');

      
    }

 

    
    
    const swatchColorMap = {
      Rose: "#FFC5CB",
      White: "#FFFFFF",
      Yellow: "#FFD270",
    };

    const cleanMetalClass = selectedMetal.replace(/[^a-zA-Z0-9]/g, "");

    // Extract base metal (after "/") or fallback to full selectedMetal
    const baseMetal = selectedMetal.split("/")[1] || selectedMetal;
    const cleanbaseMetalClass = baseMetal
      .replace(/[^a-zA-Z0-9]/g, "-")
      .toLowerCase();
    const swatchColor = swatchColorMap[baseMetal] || "#ccc";

    const metalDisplay = document.getElementById("selected-metal");
    const sizeDisplay = document.getElementById("selected-size");

    if (metalDisplay) {
      metalDisplay.innerHTML = `
    <span class="metal-label">
      Metal ${selectedMetal}
      <span class="metal-swatch-circle ${cleanbaseMetalClass}" style="background-color: ${swatchColor}"></span>
    </span>
  `;
    }
    if (sizeDisplay && selectedSize) {
      sizeDisplay.innerText = `Size ${selectedSize}`;
    } else if (sizeDisplay) {
      sizeDisplay.innerText = "";
      // Optional: sizeDisplay.style.display = 'none'; // if you want to hide it
    }

    const stickymetalDisplay = document.getElementById("selected-metal-sticky");
    const stickysizeDisplay = document.getElementById("selected-size-sticky");
    if (stickymetalDisplay)
      stickymetalDisplay.innerText = `Metal ${selectedMetal}`;
    if (stickysizeDisplay) stickysizeDisplay.innerText = `Size ${selectedSize}`;

    if (stickymetalDisplay) {
      stickymetalDisplay.innerHTML = `
    <span class="metal-label">
      Metal ${selectedMetal}
      <span class="metal-swatch-circle" style="background-color: ${swatchColor}"></span>
    </span>
  `;
    }
    if (stickysizeDisplay && selectedSize) {
      stickysizeDisplay.innerText = `Size ${selectedSize}`;
    } else if (stickysizeDisplay) {
      stickysizeDisplay.innerText = "";
      // Optional: stickysizeDisplay.style.display = 'none';
    }
    document.getElementById("variant-drawer").classList.remove("is-open");

    renderSpecs(matchedVariant.id);
    updatePriceSection(matchedVariant.id);
  });

document.querySelector(".drawer-close")?.addEventListener("click", () => {
  document.getElementById("variant-drawer").classList.remove("is-open");
});



